// 권한 메타데이터(_perm) 주입 헬퍼
// 사용법: export const fn = withPerm(async(...)=>{...}, 'GET', `${BASE}/path`)
export const withPerm = (fn, method, url) => {
  try {
    fn._perm = { method, url };
  } catch (_) { /* ignore in case of non-extensible fn */ }
  return fn;
};

